import React, { useState, useEffect } from "react";
import "../../Dashboard/Dashboard.css";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { LogoutConsultant, GetConsultantName } from "../../../services/authService";
import ConfirmationAlert from "../../AlertComponent/ConfirmationAlert";
import NormalAlert from "../../AlertComponent/NormalAlert";

const CSidebar = ({ isOpen, setIsOpen, onSelectMenu }) => {
  const navigate = useNavigate();
  const [confirmAlert, setConfirmAlert] = useState(null);
  const [alert, setAlert] = useState(null);
  const [UserName, setUserName] = useState(Cookies.get("username") || "User");

   useEffect(() => {
      const fetchUserName = async () => {
        const token = Cookies.get("ConsultantToken");
        if (!token) {
          setUserName("User");
          Cookies.remove("username");
          return;
        }
  
        try {
          const response = await GetConsultantName(token);
          if (response?.data?.status === "Success") {
            const name = response.data.name;
  
            Cookies.set("username", name, { secure: true, sameSite: "Strict" });
            setUserName(name);
          } else {
            setUserName("User");
            Cookies.remove("username");
          }
        } catch (error) {
          setAlert({
            type: "fail",
            message:
              error?.response?.data?.message ||
              "Something went wrong. Please try again.",
          });
          setUserName("User");
          Cookies.remove("username");
        }
      };
  
      fetchUserName();
    }, []);

  //  Logout handler
  const handleLogout = () => {
    setConfirmAlert({
      type: "warning",
      message: "Are you sure you want to logout?",
    });
  };

  const handleConfirmLogout = async () => {
    try {
      await LogoutConsultant(new Date());
    } catch (error) {
      const safeMessage =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";

      setAlert({
        type: "fail",
        message: safeMessage,
      });
    } finally {
      Cookies.remove("ConsultantToken");
      Cookies.remove("username");
      window.location.href = "/";
    }
  };

  const handleCancelLogout = () => setConfirmAlert(null);
  return (
    <>
      <div
        className={`sidebar ${isOpen ? "show" : ""} ${
          window.innerWidth < 768 ? "mobile-sidebar" : ""
        }`}
      >
        <div className="p-4 border-bottom d-flex align-items-center gap-3">
          <img
            src={`https://ui-avatars.com/api/?name=${UserName}&background=0D47A1&color=fff`}
            className="rounded-circle border border-white"
            width={40}
            alt={UserName}
          />

          <div className="profile-text">
            <div className="fw-bold text-white small">Welcome</div>
            <div className="text-white-50 small">{UserName}</div>
          </div>
        </div>

        <nav className="nav flex-column mt-3 px-3 gap-1">
          <Link
            to=""
            onClick={() => onSelectMenu("dashboard")}
            className="nav-link text-white d-flex align-items-center sidebar-item"
          >
            <i className="bi bi-speedometer2 me-2" />
            <span className="sidebar-label">Dashboard</span>
          </Link>

          <Link
            to="/Consultant/Dashboard/All-Jobs"
            onClick={(e) => {
              onSelectMenu("viewpostedJob");
            }}
            className="nav-link text-white d-flex align-items-center sidebar-item"
          >
            <i className="bi bi-briefcase me-2" />
            <span className="sidebar-label">Jobs</span>
          </Link>
          <Link
            to="/Consultant/Dashboard/Profiles-Shared"
            onClick={(e) => {
              onSelectMenu("cvsend");
            }}
            className="nav-link text-white d-flex align-items-center sidebar-item"
          >
            <i className="bi-send-check me-2" />
            <span className="sidebar-label">Profiles Shared</span>
          </Link>

          <Link
            to="/Consultant/Dashboard/Shortlist-Candidates"
            onClick={(e) => {
              onSelectMenu("shortlistcandidate");
            }}
            className="nav-link text-white d-flex align-items-center sidebar-item"
          >
            <i className="bi-bookmark-check me-2" />
            <span className="sidebar-label">ShortListed</span>
          </Link>

          <Link
            to="/Consultant/Dashboard/Interview-Schedule"
            onClick={(e) => {
              onSelectMenu("interviewscheduled");
            }}
            className="nav-link text-white d-flex align-items-center sidebar-item"
          >
            <i className="bi-calendar-event me-2" />
            <span className="sidebar-label">Interview Scheduled</span>
          </Link>

          <Link
            to="/Consultant/Dashboard/Selected-Candidates"
            onClick={(e) => {
              onSelectMenu("selectedcandidates");
            }}
            className="nav-link text-white d-flex align-items-center sidebar-item"
          >
            <i className="bi bi-patch-check me-2" />
            <span className="sidebar-label">Selected</span>
          </Link>
        </nav>

        <div className="logout px-3 py-2">
          <button
            onClick={handleLogout}
            className="btn btn-light w-100 d-flex align-items-center justify-content-start gap-2"
          >
            <i className="bi bi-box-arrow-right fs-5" />
            <span className="sidebar-label">Logout</span>
          </button>
        </div>

        {confirmAlert && (
          <ConfirmationAlert
            title={confirmAlert.type}
            message={confirmAlert.message}
            onClose={() => setConfirmAlert(null)}
            onConfirm={handleConfirmLogout}
            onCancel={handleCancelLogout}
          />
        )}
      </div>
      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default CSidebar;
